/**
 * Represents a single fashion brand with its gallery images
 */
export interface Brand {
  /** Unique identifier for the brand */
  id: string;

  /** Brand name */
  name: string;

  /** City location of the brand */
  city: string;

  /** Country location of the brand */
  country: string;

  /** Instagram handle (without @) */
  instagramHandle: string;

  /** URL of the thumbnail image to display in the grid */
  thumbnailUrl: string;

  /** Array of URLs for the gallery images */
  galleryImages: string[];

  /** Optional short brand story or quote (e.g., from the founder) */
  brandStory?: string;
}
